import React from 'react';
import { connect } from 'react-redux';
import { withStyles, MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import * as appPropTypes from '../../appPropTypes';
import { withRoomContext } from '../../../RoomContext';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
// Mui core
import Memo from './Memo';

const styles = (theme) =>
	({
		root :
		{
			zIndex   : 99,
			width    : '100vw',
			height   : '100vh',
			position : 'fixed',
			top      : 0,
			left     : 0
		},
		dialogPaper :
		{
			padding                        : '1%',
			width                          : '30vw',
			maxWidth                       : '400px',
			height                         : '70vh',
			backgroundColor                : '#fff',
			boxShadow                      : '2px 2px 4px #aaa',
			borderRadius                   : '0.5rem',
			display                        : 'flex',
			flexDirection                  : 'column',
			justifyContent                 : 'space-between',
			[theme.breakpoints.down('lg')] :
			{
				width : '28vw'
			},
			[theme.breakpoints.down('md')] :
			{
				width : '30vw'
			},
			[theme.breakpoints.down('sm')] :
			{
				width : '70vw'
			},
			[theme.breakpoints.down('xs')] :
			{
				width : '90vw'
			}
		},
		memoEditTitle :
		{
			textAlign : 'center',
			fontSize  : '0.8rem'
		},
		memoEditHeader :
		{
			height               : 'fit-content',
			backgroundColor      : '#919191',
			borderTopRightRadius : '0.5rem',
			borderTopLeftRadius  : '0.5rem',
			display              : 'flex',
			justifyContent       : 'flex-end',
			alignItems           : 'center'
		},
		memoTalkTime :
		{
			width           : '80%',
			margin          : '0 auto',
			backgroundColor : '#99BE18',
			color           : '#fff',
			fontSize        : '1.2rem',
			padding         : '1% 3%',
			textAlign       : 'center',
			borderRadius    : '0.5rem'
		},
		memoEditDelete :
		{
			color    : '#fff',
			fontSize : '1rem'
		},
		memoEditContent :
		{
			height : '100%'
		}
	});

const theme = createTheme({
	overrides : {
		MuiBackdrop : {
			root : {
				backgroundColor : 'transparent'
			}
		},
		MuiDialogTitle : {
			root : {
				backgroundColor : 'transparent',
				color           : '#999898',
				width           : '100%',
				fontSize        : '0.5rem',
				height          : 'fit-content',
				padding         : 0
			}
		},
		MuiDialogContent : {
			root : {
				color          : 'white',
				justifyContent : 'center',
				display        : 'flex',
				flexDirection  : 'column',
				alignItems     : 'center',
				padding        : 0
			}
		},
		MuiDialogActions : {
			root : {
				justifyContent : 'space-around'
			}
		},
		MuiTypography : {
			colorTextSecondary : {
				color : 'white'
			}
		},
		MuiPaper : {
			rounded : {
				borderRadius : '0.6rem'
			}
		}
	}
});

const OnMemoDialog = ({
	room,
	classes
}) =>
{
	const getTalkTimeString = () =>
	{
		const seconds = room.call ? parseInt(room.call.duration) : 0;

		const min = (`${parseInt(seconds/60)}`);
		const sec = (`0${parseInt(seconds%60)}`).slice(-2);

		return `${min}分${sec}秒`;
	};

	return (
		<MuiThemeProvider theme={theme}>
			<Dialog
				className={classes.root}
				open={room.memoDialogOpen}
				onClose={() => {}}
				classes={{
					paper : classes.dialogPaper
				}}
			>
				<DialogTitle id='form-dialog-title'>
					<div className={classes.memoEditTitle}>
						通話メモ
					</div>
					<div className={classes.memoTalkTime}>
						{getTalkTimeString()}
					</div>
				</DialogTitle>
				<DialogContent>
					<Memo
						btnEnabled={[ true, false, false, true, false, false ]}
						onMemoDialog
					/>
				</DialogContent>
			</Dialog>
		</MuiThemeProvider>
	);
};

OnMemoDialog.propTypes =
{
	room    : appPropTypes.Room.isRequired,
	memo    : PropTypes.object,
	classes : PropTypes.object.isRequired
};

const makeMapStateToProps = () =>
{
	const mapStateToProps = (state) =>
	{
		return {
			room : state.room,
			memo : state.room.memo
		};
	};

	return mapStateToProps;
};

const mapDispatchToProps = {
};

export default withRoomContext(connect(
	makeMapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room &&
				prev.room.memo === next.room.memo &&
				prev.room.call === next.room.call
			);
		}
	}
)(withStyles(styles)(OnMemoDialog)));